import { WbBadge } from '@agilelab/plugin-wb-platform';
import { useTheme } from '@material-ui/core';

type TypeBadgeProps = {
  typeDisplayName: string;
  kind: string;
};

export const TypeBadge = ({ typeDisplayName, kind }: TypeBadgeProps) => {
  const theme = useTheme();
  let color: string | undefined;
  switch (kind) {
    case 'system':
      color = theme.palette.relationsGraph.system;
      break;
    case 'component':
      color = theme.palette.relationsGraph.component;
      break;
    case 'domain':
      color = theme.palette.relationsGraph.system;
      break;
    default:
      color = theme.palette.grey[500];
      break;
  }
  return (
    <WbBadge variant="custom" color={color}>
      {typeDisplayName}
    </WbBadge>
  );
};
